var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 526",
    style: {
      enableBackground: "new 0 0 270 526"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.5;}\n\t.st3{fill:#D0DE8E;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st5{fill:#F9DB00;}\n\t.st6{fill:#1F54B0;}\n\t.st7{fill:#D03632;}\n\t.st8{fill:#D1D1D1;}\n\t.st9{fill:#4C702B;}\n\t.st10{fill:#93B838;}\n\t.st11{fill:#B1CC40;}\n\t.st12{fill:#CAF741;}\n\t.st13{fill:#FEF7CE;}\n\t.st14{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "127.1,206.4 173,201.3 172.7,197.3 126.9,202.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "122.9,206.9 110.3,208.2 110,204.4 122.6,203.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.6,
    y: 196.9,
    transform: "matrix(0.991 -0.134 0.134 0.991 -25.4064 23.3253)",
    className: "st1",
    width: 4.1,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.4,195.9l1.6,1.1l1.2,7.4l-1.1,1.5 M163.2,194.8l-1.1,1.6l1.2,7.3l1.5,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.1,199.9l1.4,1.2l0.4,7.5l-1.2,1.4 M128,199.5l-1.2,1.4l0.4,7.4l1.4,1.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "85.6,23.7 184.8,8.8 185.2,12.5 87.7,27.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 9.4,
    transform: "matrix(0.9919 -0.1267 0.1267 0.9919 -0.3678 20.6359)",
    className: "st1",
    width: 3.4,
    height: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.3,8.1l-1.1,1.5l1,7.4l1.5,1.1 M158.2,8.5l1.5,1.1l1,7.4l-1.1,1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.7,
    y: 13.2,
    transform: "matrix(0.8514 -0.5246 0.5246 0.8514 12.9662 78.708)",
    className: "st1",
    width: 3.4,
    height: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.4,10.6l-0.4,1.8l3.9,6.3l1.8,0.5 M140,13.5l1.9,0.4l3.9,6.4l-0.4,1.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.7,476c-5.6-0.2-7.3,4.9-7.5,6.7c-0.6,4,1.2,8.3,6.2,8.5c5.9,0.2,6.4-5.5,6.5-7S156.4,476.3,150.7,476"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153.5,485.9c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8S153.5,483.8,153.5,485.9 L153.5,485.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.2,485.7c0,1.4-1.2,2.6-2.6,2.5c0,0,0,0,0,0l-5.8-0.1c-1.4,0-2.5-1.2-2.5-2.6l0.2-9.5 c0-1.4,1.2-2.5,2.6-2.5l5.8,0.1c1.4,0,2.5,1.2,2.5,2.6c0,0,0,0,0,0L125.2,485.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.7,481.2c0,2.1-1.8,3.7-3.8,3.7c-2.1,0-3.7-1.8-3.7-3.8c0-2.1,1.8-3.7,3.8-3.7c0,0,0,0,0,0 C121.1,477.4,122.8,479.1,122.7,481.2C122.7,481.2,122.7,481.2,122.7,481.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.7,461c-4.8,0.3-4.5,4.9-4.5,7.8c0,2,0.3,7.7,5.5,7.3c4.6-0.4,5.1-4.8,4.7-8.2 C146,465.2,145.6,460.7,140.7,461"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.5,437.9c4.8-0.2,5.1-6.5,5.2-9.9c0.1-4.5,0.2-11-4.3-11.2c-5-0.3-4.8,6.4-4.9,11.1 C125.4,432.1,124.9,438.1,129.5,437.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M133.2,434.1c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8l0,0 C131.5,430.3,133.2,432,133.2,434.1C133.2,434.1,133.2,434.1,133.2,434.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M133.8,420.7c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8l0,0 C132.1,416.9,133.8,418.6,133.8,420.7C133.8,420.7,133.8,420.7,133.8,420.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.2,470.2c-2.8,0-27.8-0.2-31.5-1.8c-4.3-1.9-4.5-7.1-4.5-7.4l2.2-0.1h-1.1h1.1c0,0,0.2,4.1,3.1,5.3 c2.4,1,19.6,1.5,30.6,1.6L187.2,470.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M103.4,526.4l-4.8-0.3c0-0.3,2-28,1.8-65.4c-0.3-49.1-2.5-76.3-4.5-102.5c-1-12.6-1.9-24.5-2.6-38.3 c-0.5-9.4-2.2-30.9-4.4-58c-2.1-26.2-4.8-58.8-7.2-91.5C75.6,87.7,70.3,1.1,70.2,0.3L75,0c0.1,0.9,5.3,87.4,11.4,170.1 c2.4,32.7,5.1,65.3,7.2,91.5c2.2,27.2,4,48.7,4.5,58.2c0.7,13.7,1.6,25.6,2.6,38.1c2.1,26.3,4.2,53.6,4.5,102.9 C105.4,498.2,103.4,526.2,103.4,526.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.2,197.4l-0.3-2.2c1.5-0.2,3-0.8,4.3-1.6c1.7-1.4,2.6-3.6,2.4-5.9c-0.1-1.7-0.7-5.8-1.6-11.5l-0.9-5.8 c-0.7-4.4-1.2-11.3-1.7-18.6c-0.5-6.9-1-14.1-1.7-19c-0.8-5.7-1.7-14.4-2.4-21.3c-0.6-5.2-1-9.7-1.3-11.6c-0.2-1.7-0.7-3.5-1.2-5.4 c-1-3.5-1.6-7-1.8-10.6c-0.1-2.2-0.2-5.2-0.3-8.1c-0.2-4.7-0.4-9.3-0.4-10.6s-0.6-1.6-0.8-1.7c-1-0.7-3-0.2-3.6,0l-0.7-2.1 c0.3-0.1,3.4-1.1,5.6,0.3c1.1,0.8,1.7,2.1,1.7,3.4c0.1,1.3,0.3,6,0.4,10.7c0.1,3,0.2,6,0.3,8.1c0.3,3.5,0.9,6.9,1.8,10.2 c0.5,1.9,0.9,3.7,1.2,5.6c0.3,2,0.8,6.4,1.3,11.6c0.7,6.9,1.7,15.6,2.4,21.3c0.7,4.9,1.2,12.1,1.7,19.1c0.5,7.3,1,14.1,1.7,18.4 l0.9,5.8c0.9,5.7,1.5,9.8,1.6,11.7c0.3,2.9-0.9,5.7-3.1,7.6C91.9,196.8,88.5,197.3,88.2,197.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.7,35.4c-16.6-0.2-22.1,11.5-24.1,21.7c-4.1,20.9-3.4,27.5-5.1,36.2s-11,39.6-15.2,53.4 c-4.2,14-12.4,28.1-10,42c1,4,1.5,11.4-0.1,15.5c-1.4,3.8-4,5.4-7.1,10c-4.2,6.1-2,26.1-1.9,38.7c0.1,14.9,0.1,72.1-2.1,88.2 c-2.6,18.9,7.2,31.5,23.4,30.6c12.1-0.7,22.4-6.2,22.5-21.2c-0.2-11.8,1.2-20.2-1.9-26.4c-2-4.1-4.9-6.6-3.8-13.3 c1.7-10.8,8.6-10.6,10.6-21.1c1.4-11.3,3.6-8.4,5.1-25.2s-3.9-18.3-1.5-31.9c1-6.4,1.5-13,1.4-19.5c-0.1-10.2-8.9-5.8-9.2-11.6 c-0.4-4.9,4.9-6.9,8.6-11.6c3.4-4.3,4.4-7.5,5.8-15.1c2-10,4.7-19.9,8-29.5c3.2-9.9,9.9-47.3,17.8-54.3c6.4-5.7,6.1-14.4,5.6-22 C199,56.9,189.7,35.6,172.7,35.4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M135.2,213.1c-13.2,3.9-10.5,11.9-8.6,25c0.7,5,1.7,7.2-1.2,14c-4.4,10.1-2.6,8.8-2.9,23.1 c-0.2,8.8,0.5,15.9,0.5,25.5c0,17.1-4.4,34.2-4.4,45c-0.3,19.1,20.9,12.4,20.8-4.2c0-16.4,0.9-25.9,0.9-32c0-6,4-26.6,4.3-32.4 c0.6-12.2,1.8-14.2,2.3-17.1c0.8-4.3,3.7-28.9,2.8-40.1C149.3,216.6,147.6,209.5,135.2,213.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M157.6,92.9c-1.3,5.5-6.5,25-10.9,39.3s-7.9,27.7-12.9,38.5c-3.7,8.2-5.9,14.6,0.3,18.4 c6.6,3.9,16.4-1.4,20.6-14.8c6.7-21.4,10-34.3,13.2-47.1s5.5-16.5,5.9-23.6c0.2-2.4,0.1-4-0.6-9C171.1,94.3,159,93,157.6,92.9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M180.4,49.9c-2.1-4.1-7-6-11.3-4.2c-6,2.3-6.9,7.4-7.3,10.8c-0.7,5.5,0.9,6.5,0.4,10.7 c-0.6,4.9-1.6,9.7-2.9,14.5c-1.1,4.3,0.4,4.2-0.8,7.8c-3.1,9.9-2.7,12.7,7.4,13.1c11,0.5,6.7-8.3,6.5-12.3 c-0.2-3.6,3.2-5.8,5.9-10.8c1.3-2.5,5.5-4.4,6.5-10.9c0.6-3.6-0.7-6.3-1.7-8.7C181.7,56.5,182.3,53.5,180.4,49.9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M169.9,47.5c-4.5,1.5-5.6,5.5-6.3,10c-0.6,3.9,0.4,5.9,0.3,9.5c-0.2,4.6-4.2,12.5-0.5,15.7 c3.8,2.9,9.2,2.1,12.1-1.7c0.3-0.4,0.6-0.9,0.9-1.4c2.2-4.1,4.9-5.2,6.3-9.2c1.7-4.7,0.7-7.6-1.1-12.2 C180.2,54.7,179.1,44.4,169.9,47.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M150.1,255.4c-3,0.2-2.8,4.3-3.5,6.9s-1.4,5.3,0.3,7.9s5.4,2.2,6.7,1.4c1.8-1.2,2.3-5.6,1.7-8.2 C154.8,261.1,153.2,255.2,150.1,255.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M121.8,242.3c-4,0.1-2.6,4.5-3.8,6.9c-1,2-2.8,5.7,0,6.9c4.5,1.9,7.2-2.6,7.8-5.7 C126.3,248,126.6,242.2,121.8,242.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.8,90.7c-1.6-1.8-1.9-4.3,0.9-7.5c2.4-2.7,4.8-1.9,5.8-1.3s3.6,3.6,0,6.9 C184.9,91.2,182.5,92.6,180.8,90.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M152.6,73.8c-0.7,2.8,2,4,3.4,4.2s3.5,1.1,4.6-2.6s0.9-4.8-1.7-6S153.3,71,152.6,73.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M183.1,55.2c-0.8,1.8-0.5,3.9,0.8,5.3c2.2,2.5,5.3,2.7,6,1c0.9-2.4-0.5-4.1-1.4-5.5 C187.2,54.2,184.1,52.4,183.1,55.2"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M70.7,97.2c0,1.6-1.3,2.9-2.9,2.8c-1.6,0-2.9-1.3-2.8-2.9c0-1.6,1.3-2.8,2.9-2.8 C69.4,94.3,70.7,95.6,70.7,97.2C70.7,97.2,70.7,97.2,70.7,97.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M68.5,105.1c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9c0,0,0,0,0,0 C67.3,102.3,68.5,103.6,68.5,105.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M78.1,137.6c1.1-1.2,1-3-0.1-4c-0.2-0.2-0.4-0.3-0.6-0.5c1.2-1,1.3-2.9,0.3-4.1c-1-1.2-2.9-1.3-4.1-0.3 c-1.2,1-1.3,2.9-0.3,4.1c0.2,0.3,0.5,0.5,0.9,0.7c-1.2,1-1.3,2.8-0.3,4c0.1,0.1,0.2,0.2,0.3,0.3c-1.1,1.2-1,3,0.1,4.1 c1.2,1.1,3,1,4.1-0.1S79.3,138.7,78.1,137.6C78.1,137.6,78.1,137.6,78.1,137.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M117.3,157.8c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9c0,0,0,0,0,0 C116,154.9,117.3,156.2,117.3,157.8C117.3,157.8,117.3,157.8,117.3,157.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M112.1,204c-0.1-1.3-1.1-2.3-2.3-2.5c0.5-0.5,0.8-1.2,0.8-1.9c0-0.5-0.1-0.9-0.4-1.4c1.4-0.7,2-2.4,1.4-3.8 s-2.4-2-3.8-1.4c-1,0.5-1.6,1.5-1.6,2.6c-0.9-1.3-2.7-1.6-4-0.7c-0.4,0.3-0.8,0.7-1,1.2c-0.7-0.3-1.5-0.3-2.2,0 c-0.9-1.3-2.7-1.6-4-0.7c-0.7,0.5-1.2,1.4-1.2,2.3c-1.6,0.3-2.6,1.7-2.3,3.3c0.2,1.4,1.5,2.4,2.9,2.4c0.2,0,0.4,0,0.6-0.1 c0.7,1.4,2.4,2,3.8,1.3c1-0.5,1.6-1.5,1.6-2.6c0-0.1,0-0.3,0-0.4c1.1,0,2.1-0.7,2.5-1.8c0.3,0.1,0.7,0.2,1,0.2 c0.5,0,0.9-0.1,1.3-0.4c0.1,1.3,1.1,2.4,2.3,2.6c-1.1,1.1-1.1,2.8,0,3.9c0,0,0,0,0,0c-1.4,0.7-1.9,2.3-1.2,3.7 c0.7,1.4,2.3,1.9,3.7,1.2c0.7-0.3,1.2-1,1.4-1.7c0.1,0,0.2,0,0.4,0c1.5,0,2.8-1.2,2.8-2.7C114.6,205.3,113.5,204.1,112.1,204"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M119.1,169.2c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9c0,0,0,0,0,0 C117.8,166.4,119,167.7,119.1,169.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M181.1,487.1l7.1,12l7-3.2l3.8,30.4l-91.2-0.5l-0.1-25l9.3-6.6l10.1,6.1l8-6l2.4,1.5 c-0.1-0.3-0.1-0.6-0.1-0.9c0-1.5,1.2-2.8,2.7-2.8c1.5,0,2.8,1.2,2.8,2.7c0,1.4-1,2.6-2.4,2.7l3.1,2l3.2-0.9 c-0.1-0.2-0.1-0.5-0.1-0.8c0-1.5,1.2-2.8,2.7-2.8c0,0,0,0,0,0c0.7,0,1.4,0.3,1.9,0.8c0.4-1.5,1.9-2.3,3.4-1.9c1.2,0.3,2,1.4,2,2.6 c0,0.1,0,0.2,0,0.3l2.8,0.3l10.1-5.6L181.1,487.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M84.1,204.6c0,2.8-2.3,5-5.1,5s-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0C81.9,199.6,84.1,201.8,84.1,204.6 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M75.8,197.8c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1c0,0,0,0,0,0 C73.5,192.8,75.8,195,75.8,197.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M184.9,516.9c0,2.8-2.3,5.1-5,5.1c-2.8,0-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C182.6,511.8,184.9,514.1,184.9,516.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M203,515.9c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C200.7,510.9,203,513.1,203,515.9 C203,515.9,203,515.9,203,515.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M184.5,506c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C182.3,501,184.5,503.2,184.5,506"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.4,511.4c0,2.8-2.3,5-5,5c-2.8,0-5.1-2.3-5.1-5c0-2.8,2.3-5.1,5-5.1c0,0,0,0,0,0 C191.2,506.4,193.4,508.7,193.4,511.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M201.6,505.4c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C199.4,500.4,201.6,502.6,201.6,505.4 C201.6,505.4,201.6,505.4,201.6,505.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M201.6,494.9c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C199.4,489.9,201.6,492.1,201.6,494.9 C201.6,494.9,201.6,494.9,201.6,494.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M192.9,499.8c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5c0-2.8,2.3-5.1,5-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9 C192.9,499.7,192.9,499.8,192.9,499.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M191.3,489.3c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5c0-2.8,2.3-5.1,5-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9 C191.3,489.2,191.3,489.3,191.3,489.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M183.3,495.9c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C181.1,490.9,183.3,493.1,183.3,495.9 C183.3,495.9,183.3,495.9,183.3,495.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M173.8,492.6c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C171.6,487.5,173.8,489.8,173.8,492.6C173.8,492.6,173.8,492.6,173.8,492.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M181.4,485.8c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.2-4.9,4.9-4.9c2.8,0,5,2.2,5.1,4.9 C181.4,485.7,181.4,485.8,181.4,485.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M169.6,456.6c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C167.4,451.5,169.6,453.8,169.6,456.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M178.5,460.2c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C176.2,455.1,178.5,457.4,178.5,460.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161.6,436.2c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1s2.3-5,5.1-5c0,0,0,0,0,0 C159.4,431.1,161.6,433.3,161.6,436.2C161.6,436.1,161.6,436.1,161.6,436.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.9,401.6c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5s2.2-5.1,5-5.1c0,0,0,0,0,0 C162.7,396.6,164.9,398.8,164.9,401.6C164.9,401.6,164.9,401.6,164.9,401.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161.6,358.3c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1s2.3-5,5.1-5c0,0,0,0,0,0 C159.4,353.2,161.6,355.4,161.6,358.3C161.6,358.2,161.6,358.2,161.6,358.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M162.4,371.5c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1s2.3-5,5.1-5c0,0,0,0,0,0 C160.2,366.4,162.4,368.7,162.4,371.5C162.4,371.4,162.4,371.5,162.4,371.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121.8,495.1c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5-5c2.8,0,5,2.2,5.1,4.9 C121.8,495.1,121.8,495.1,121.8,495.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M112.8,500.6c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1c0,0,0,0,0,0 C110.6,495.5,112.8,497.8,112.8,500.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.3,500.2c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C128.1,495.1,130.3,497.4,130.3,500.2C130.3,500.1,130.3,500.2,130.3,500.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M131.3,521c0,2.8-2.3,5-5,4.9s-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C129,515.9,131.3,518.2,131.3,521 C131.3,521,131.3,521,131.3,521"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.5,511.1c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C128.3,506,130.5,508.2,130.5,511.1C130.5,511,130.5,511,130.5,511.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M138.9,505.4c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C136.6,500.4,138.9,502.6,138.9,505.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M139.8,515.5c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5c0-2.8,2.2-5.1,5-5.1c0,0,0,0,0,0 C137.5,510.5,139.8,512.8,139.8,515.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M149,520.6c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.2-4.9,4.9-4.9C146.7,515.5,149,517.8,149,520.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M148.6,510.5c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C146.3,505.4,148.6,507.7,148.6,510.5C148.6,510.4,148.6,510.5,148.6,510.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M139.4,495.1c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5-5c2.8,0,5,2.2,5.1,4.9 C139.4,495.1,139.4,495.1,139.4,495.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M148,500.4c0,2.8-2.3,5.1-5,5.1c-2.8,0-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0c2.8,0,5,2.2,5.1,4.9 C148,500.3,148,500.3,148,500.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M167.4,519.4c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S167.4,516.6,167.4,519.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M157.7,515.1c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C155.5,510.1,157.7,512.4,157.7,515.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M156.9,504.6c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C154.7,499.6,156.9,501.9,156.9,504.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M166.2,508.7c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5c0-2.8,2.3-5.1,5-5.1c0,0,0,0,0,0 C164,503.7,166.2,505.9,166.2,508.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M175.8,513.1c-0.2,2.8-2.6,4.9-5.4,4.7c-2.8-0.2-4.9-2.6-4.7-5.4c0.2-2.8,2.6-4.9,5.4-4.7c0,0,0,0,0,0 C173.8,507.9,175.9,510.3,175.8,513.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M165.3,498.2c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C163,493.2,165.3,495.4,165.3,498.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M174.6,502.7c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C172.4,497.6,174.6,499.9,174.6,502.7 C174.6,502.7,174.6,502.7,174.6,502.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.9,463.1c0,2.8-2.3,5-5.1,5s-5-2.3-5-5.1c0-2.8,2.3-5,5-5C94.6,458,96.9,460.3,96.9,463.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88,458.3c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C85.8,453.3,88,455.5,88,458.3 C88,458.3,88,458.3,88,458.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.7,452.4c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C94.5,447.3,96.7,449.6,96.7,452.4 C96.7,452.4,96.7,452.4,96.7,452.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.4,447.8c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1h0c2.8,0,5,2.2,5.1,4.9 C87.4,447.8,87.4,447.8,87.4,447.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.5,442.1c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C94.2,437.1,96.5,439.3,96.5,442.1 C96.5,442.1,96.5,442.1,96.5,442.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M105.7,437.1c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C103.5,432.1,105.7,434.3,105.7,437.1 C105.7,437.1,105.7,437.1,105.7,437.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.7,432c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C94.5,426.9,96.7,429.2,96.7,432 C96.7,432,96.7,432,96.7,432"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.8,427.7c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C99.5,422.7,101.8,424.9,101.8,427.7C101.8,427.7,101.8,427.7,101.8,427.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.1,421.7c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1h0C93.9,416.6,96.1,418.9,96.1,421.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.7,414.4c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C88.5,409.4,90.7,411.6,90.7,414.4 C90.7,414.4,90.7,414.4,90.7,414.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M92.2,405c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C90,399.9,92.2,402.2,92.2,405 C92.2,405,92.2,405,92.2,405"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.9,411.7c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C97.6,406.6,99.9,408.9,99.9,411.7 C99.9,411.7,99.9,411.7,99.9,411.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.7,397.5c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C97.4,392.5,99.7,394.7,99.7,397.5 C99.7,397.5,99.7,397.5,99.7,397.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.2,395.6c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1h0C86.9,390.5,89.2,392.8,89.2,395.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.1,381.5c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1h0c2.8,0,5,2.2,5.1,4.9 C96.1,381.4,96.1,381.4,96.1,381.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.1,387.5c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1h0C93.9,382.5,96.1,384.7,96.1,387.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.8,376.3c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C84.6,371.3,86.9,373.5,86.8,376.3 C86.9,376.3,86.9,376.3,86.8,376.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.5,356.1c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C84.2,351.1,86.5,353.3,86.5,356.1 C86.5,356.1,86.5,356.1,86.5,356.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87,365.6c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C84.7,360.6,87,362.8,87,365.6 C87,365.6,87,365.6,87,365.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.1,371.4c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1h0c2.8,0,5,2.2,5.1,4.9 C96.1,371.3,96.1,371.3,96.1,371.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.8,361.4c0,2.8-2.3,5-5,5c-2.8,0-5.1-2.3-5.1-5c0-2.8,2.3-5,5-5C94.5,356.3,96.7,358.6,96.8,361.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95.2,351.7c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C93,346.6,95.2,348.8,95.2,351.7 C95.2,351.6,95.2,351.6,95.2,351.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M112.4,521.3c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C110.2,516.3,112.4,518.6,112.4,521.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M112.4,510.9c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C110.2,505.8,112.4,508.1,112.4,510.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121.4,516.5c0,2.8-2.3,5-5,5c-2.8,0-5.1-2.3-5.1-5c0-2.8,2.3-5,5-5h0C119.1,511.4,121.4,513.7,121.4,516.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121.8,506c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.2-4.9,4.9-4.9C119.5,501,121.8,503.2,121.8,506"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100.2,514.4c0,2.8-2.3,5-5,4.9s-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C98,509.3,100.2,511.5,100.2,514.4 C100.2,514.3,100.2,514.3,100.2,514.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.1,502.8c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C90.8,497.7,93.1,500,93.1,502.8C93.1,502.8,93.1,502.8,93.1,502.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.8,509.8c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C91.6,504.7,93.8,507,93.8,509.8C93.8,509.8,93.8,509.8,93.8,509.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.4,503.9c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C99.1,498.8,101.4,501.1,101.4,503.9 C101.4,503.8,101.4,503.9,101.4,503.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.8,493.9c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1c0,0,0,0,0.1,0 C99.6,488.8,101.8,491,101.8,493.9C101.8,493.8,101.8,493.8,101.8,493.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.7,494.2c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0C89.4,489.2,91.7,491.5,91.7,494.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87,486.9c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C84.8,481.8,87,484.1,87,486.9 C87,486.8,87,486.9,87,486.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.7,484.6c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C94.5,479.6,96.7,481.8,96.7,484.6C96.7,484.6,96.7,484.6,96.7,484.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.6,479.5c0,2.8-2.3,5-5.1,5s-5-2.3-5-5.1c0-2.8,2.3-5,5-5C85.4,474.4,87.6,476.7,87.6,479.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.7,474.3c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S96.7,471.6,96.7,474.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.8,468.8c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C85.6,463.7,87.8,466,87.8,468.8 C87.8,468.8,87.8,468.8,87.8,468.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.1,231.6c0,2.8-2.3,5.1-5,5.1c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5-5.1c0,0,0,0,0,0 C95.9,226.6,98.1,228.8,98.1,231.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M106.9,212.6c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S106.9,209.8,106.9,212.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95.8,204.8c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C93.5,199.7,95.8,202,95.8,204.8 C95.8,204.8,95.8,204.8,95.8,204.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M108.9,203.5c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S108.9,200.8,108.9,203.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100.4,207.9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S100.4,205.1,100.4,207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.2,286.4c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C99,281.3,101.2,283.6,101.2,286.4 C101.2,286.4,101.2,286.4,101.2,286.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100.6,275.9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S100.6,273.1,100.6,275.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M106.1,314.2c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C103.8,309.1,106.1,311.4,106.1,314.2 C106.1,314.1,106.1,314.2,106.1,314.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M107.6,305.7c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C105.3,300.7,107.6,302.9,107.6,305.7 C107.6,305.7,107.6,305.7,107.6,305.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95.7,341.9c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C93.5,336.8,95.7,339,95.7,341.9 C95.7,341.8,95.7,341.8,95.7,341.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95.5,331.2c0,2.8-2.3,5-5,5c-2.8,0-5.1-2.3-5.1-5c0-2.8,2.3-5,5-5C93.3,326.1,95.5,328.4,95.5,331.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.3,346.6c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.2-4.9,4.9-4.9c2.8,0,5,2.2,5.1,4.9 C86.3,346.5,86.3,346.6,86.3,346.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.8,336.5c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C84.6,331.5,86.9,333.7,86.8,336.5 C86.9,336.5,86.9,336.5,86.8,336.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.1,326.4c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C83.8,321.4,86.1,323.6,86.1,326.4 C86.1,326.4,86.1,326.4,86.1,326.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M85.5,315.5c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S85.5,312.8,85.5,315.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95,320.9c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C92.8,315.8,95,318.1,95,320.9 C95,320.8,95,320.9,95,320.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M94.8,310.8c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C92.5,305.7,94.7,308,94.8,310.8 C94.8,310.7,94.8,310.8,94.8,310.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.8,300.5c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.2-4.9,4.9-4.9C91.5,295.4,93.8,297.7,93.8,300.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.1,290.2c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C88.8,285.1,91.1,287.4,91.1,290.2 C91.1,290.1,91.1,290.2,91.1,290.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.9,276.2c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1h0c2.8,0,5,2.2,5.1,4.9 C89.9,276.1,89.9,276.2,89.9,276.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.9,283.8c-0.3,2.8-2.9,4.7-5.6,4.4c-2.8-0.3-4.7-2.9-4.4-5.6c0.3-2.8,2.9-4.7,5.6-4.4c0,0,0,0,0,0 C88.2,278.5,90.2,281,89.9,283.8C89.9,283.8,89.9,283.8,89.9,283.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.7,264.1c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5c0-2.8,2.2-5.1,5-5.1c0,0,0,0,0,0 C88.4,259.1,90.7,261.3,90.7,264.1C90.7,264.1,90.7,264.1,90.7,264.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.5,253.9c0,2.8-2.2,5-5,5s-5-2.2-5-5c0-2.8,2.2-5,5-5C88.2,248.9,90.4,251.1,90.5,253.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.7,241.6c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C86.5,236.6,88.7,238.8,88.7,241.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.2,229.2c0,2.8-2.3,5.1-5.1,5.1s-5-2.3-5-5.1c0-2.8,2.3-5.1,5-5.1c2.8,0,5,2.2,5.1,4.9 C88.2,229.1,88.2,229.1,88.2,229.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.4,211.5c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1c0,0,0,0,0.1,0 C84.2,206.5,86.4,208.7,86.4,211.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M76.2,211.4c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C73.9,206.4,76.2,208.6,76.2,211.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M74,205.2c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C71.8,200.1,74,202.4,74,205.2 C74,205.2,74,205.2,74,205.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.6,219.7c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S87.6,216.9,87.6,219.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.4,197.5c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1c0,0,0,0,0.1,0 C84.2,192.5,86.4,194.7,86.4,197.5C86.4,197.5,86.4,197.5,86.4,197.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M79.3,193c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S79.3,190.2,79.3,193"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161,335.6c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5-5C158.7,330.6,161,332.8,161,335.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M171.9,312.8c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C169.7,307.8,171.9,310,171.9,312.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M179.1,314.5c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5c0-2.8,2.2-5.1,5-5.1c0,0,0.1,0,0.1,0 C176.8,309.5,179.1,311.7,179.1,314.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M156,311.9c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1s2.3-5,5.1-5c0,0,0,0,0,0C153.8,306.9,156,309.2,156,311.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.5,310.8c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5s2.2-5.1,5-5.1c0,0,0,0,0,0 C162.2,305.7,164.5,308,164.5,310.8C164.5,310.7,164.5,310.8,164.5,310.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100.6,262.9c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C98.4,257.8,100.6,260.1,100.6,262.9 C100.6,262.8,100.6,262.9,100.6,262.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.1,252.8c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C96.9,247.7,99.1,250,99.1,252.8C99.1,252.7,99.1,252.8,99.1,252.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99,242.2c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S99,239.4,99,242.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M160.7,348c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C158.4,342.9,160.7,345.2,160.7,348 C160.7,348,160.7,348,160.7,348"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M119,198.5c0,2.8-2.3,5-5.1,4.9s-5-2.3-4.9-5.1c0-2.7,2.2-4.9,4.9-4.9c2.8,0,5,2.2,5.1,4.9 C119,198.4,119,198.5,119,198.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M78.1,123c0,2.8-2.2,5.1-5,5.1s-5.1-2.2-5.1-5c0-2.8,2.2-5.1,5-5.1c0,0,0,0,0.1,0 C75.8,118,78.1,120.2,78.1,123"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M68.4,120.3c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C66.2,115.3,68.4,117.5,68.4,120.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M119.9,132c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5c0-2.8,2.2-5.1,5-5.1c0,0,0,0,0,0 C117.6,127,119.8,129.2,119.9,132C119.9,132,119.9,132,119.9,132"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M112.1,144.8c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C109.9,139.7,112.1,142,112.1,144.8 C112.1,144.7,112.1,144.8,112.1,144.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M74,69c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S74,66.2,74,69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M76.8,76.4c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S76.8,73.6,76.8,76.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M67.8,75c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,5-5C65.5,70,67.8,72.2,67.8,75 C67.8,75,67.8,75,67.8,75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M73.4,45.4c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S73.4,42.6,73.4,45.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M74,54.7c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S74,52,74,54.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M210.4,60.4c0,2.8-2.3,5.1-5.1,5.1c-2.8,0-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1l0,0 C208.1,55.3,210.4,57.6,210.4,60.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M220.7,49.8c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0C218.4,44.7,220.7,47,220.7,49.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M209.8,80.8c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0 C207.5,75.7,209.8,78,209.8,80.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M204.2,102c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5s2.2-5.1,5-5.1c0,0,0,0,0,0 C201.9,97,204.1,99.2,204.2,102"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M195.2,125.7c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5c0-2.8,2.2-5.1,5-5.1c0,0,0,0,0,0 C193,120.7,195.2,123,195.2,125.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M206.9,92c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S206.9,89.2,206.9,92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M177.8,201.2c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C175.6,196.2,177.8,198.5,177.8,201.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M211,11.1c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S211,8.4,211,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M218,7.6c0,2.8-2.3,5.1-5,5.1s-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0C215.7,2.6,218,4.8,218,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M220.3,15.2c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5s2.2-5.1,5-5.1c0,0,0,0,0,0 C218,10.2,220.3,12.4,220.3,15.2C220.3,15.2,220.3,15.2,220.3,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M198.9,12.9c0,2.8-2.2,5.1-5,5.1c-2.8,0-5.1-2.2-5.1-5s2.2-5.1,5-5.1c0,0,0,0,0,0 C196.7,7.8,198.9,10.1,198.9,12.9C198.9,12.8,198.9,12.9,198.9,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M205,12.1c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C202.7,7.1,205,9.3,205,12.1 C205,12.1,205,12.1,205,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M190.9,11.4c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5C188.7,6.4,190.9,8.6,190.9,11.4 C190.9,11.4,190.9,11.4,190.9,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M114.6,24.3c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S114.6,21.6,114.6,24.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M118.3,17.5c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C116.1,12.5,118.3,14.7,118.3,17.5 C118.3,17.5,118.3,17.5,118.3,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M94.6,26.5c0,2.8-2.3,5-5.1,5c-2.8,0-5-2.3-5-5.1c0-2.8,2.3-5,5-5c2.8,0,5,2.2,5.1,4.9 C94.6,26.4,94.6,26.4,94.6,26.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M97.9,17.6c0,2.8-2.2,5.1-5,5.1s-5.1-2.2-5.1-5c0-2.8,2.2-5.1,5-5.1c0,0,0,0,0.1,0 C95.6,12.6,97.8,14.9,97.9,17.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M104.5,25.9c0,2.8-2.3,5.1-5,5.1c-2.8,0-5.1-2.3-5.1-5s2.3-5.1,5-5.1c0,0,0,0,0,0 C102.3,20.8,104.5,23.1,104.5,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M108,15.8c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S108,13,108,15.8L108,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M84.6,28.1c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C82.3,23.1,84.6,25.3,84.6,28.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.6,21.8c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-5C86.4,16.8,88.6,19,88.6,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M83.5,16.5c0,2.8-2.3,5-5,4.9c-2.8,0-5-2.3-4.9-5c0-2.7,2.3-4.9,5-4.9C81.3,11.4,83.5,13.6,83.5,16.5 C83.5,16.4,83.5,16.4,83.5,16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M71.8,26.6c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5C69.6,21.6,71.8,23.8,71.8,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M72,21.1c0,2.8-2.3,5-5.1,5s-5-2.3-5-5.1c0-2.8,2.3-5,5.1-5c0,0,0,0,0,0C69.8,16.1,72,18.3,72,21.1 C72,21.1,72,21.1,72,21.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M72.4,37.2c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S72.4,34.5,72.4,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M216.8,63.4c0,2.8-2.3,5-5.1,5s-5-2.3-5-5.1c0-2.8,2.3-5,5-5c2.8,0,5,2.2,5.1,4.9 C216.8,63.3,216.8,63.3,216.8,63.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M204.7,38.8c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C202.4,33.8,204.7,36,204.7,38.8 C204.7,38.8,204.7,38.8,204.7,38.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.7,185.6c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C89.3,182.3,90.7,183.7,90.7,185.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.9,189.6c0,2.8-2.3,5.1-5.1,5.1s-5-2.3-5-5.1c0-2.8,2.3-5.1,5-5.1c2.8,0,5,2.2,5.1,4.9 C88.9,189.5,88.9,189.5,88.9,189.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M92.9,179.2c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c0,0,0,0,0,0 C91.4,175.8,92.9,177.3,92.9,179.2C92.9,179.2,92.9,179.2,92.9,179.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.9,172.6c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C90.4,169.3,91.9,170.7,91.9,172.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.1,166c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C89.6,162.7,91.1,164.2,91.1,166C91.1,166,91.1,166,91.1,166"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.3,159.1c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C88.8,155.8,90.3,157.3,90.3,159.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.8,152.4c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C88.3,149,89.8,150.5,89.8,152.4C89.8,152.3,89.8,152.3,89.8,152.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M110.4,176.4c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C108.9,173.1,110.4,174.6,110.4,176.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M133.3,141.9c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3l0,0 C131.8,138.6,133.3,140,133.3,141.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.2,126.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c0,0,0,0,0,0 C128.7,123,130.2,124.5,130.2,126.3C130.2,126.3,130.2,126.3,130.2,126.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.8,119.5c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C122.3,116.2,123.8,117.7,123.8,119.5C123.8,119.5,123.8,119.5,123.8,119.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135,113.7c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3l0,0 C133.5,110.4,135,111.8,135,113.7C135,113.7,135,113.7,135,113.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M129.8,105.5c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C128.3,102.2,129.8,103.7,129.8,105.5L129.8,105.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135,101.3c0,1.8-1.4,3.3-3.3,3.4c-1.8,0-3.3-1.4-3.4-3.3c0-1.8,1.4-3.3,3.3-3.4c0,0,0.1,0,0.1,0 C133.5,98,135,99.5,135,101.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M140.3,92.1c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C138.8,88.8,140.3,90.3,140.3,92.1C140.3,92.1,140.3,92.1,140.3,92.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M167.1,431.3c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c0,0,0,0,0,0 C165.6,428,167.1,429.5,167.1,431.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161.2,425.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c0,0,0,0,0.1,0 C159.8,422,161.3,423.5,161.2,425.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M162.6,411.5c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C161.1,408.2,162.6,409.7,162.6,411.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M162.8,392.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C161.3,389,162.8,390.4,162.8,392.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161.6,384.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C160.2,381,161.6,382.5,161.6,384.3C161.6,384.3,161.6,384.3,161.6,384.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161.1,299c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3l0,0C159.6,295.7,161.1,297.2,161.1,299"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M163,286.8c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c0,0,0,0,0,0 C161.5,283.5,163,285,163,286.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M165.7,275.1c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c0,0,0,0,0,0 C164.2,271.8,165.7,273.3,165.7,275.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M166.1,263.5c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3l0,0 C164.6,260.2,166.1,261.6,166.1,263.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M169,252.8c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3C167.5,249.5,169,251,169,252.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M168.4,242.9c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C167,239.6,168.4,241,168.4,242.9C168.4,242.9,168.4,242.9,168.4,242.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M169,235.8c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.7,2.2-5,4.9-5C166.7,230.8,169,233,169,235.8 C169,235.8,169,235.8,169,235.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M171.6,225c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C170.1,221.7,171.5,223.2,171.6,225"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M171.6,216.8c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C170.1,213.5,171.5,215,171.6,216.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M176.6,174.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C175.1,171,176.6,172.5,176.6,174.3L176.6,174.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M180.1,164.4c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C178.6,161.1,180.1,162.6,180.1,164.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M183.4,154.1c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3l0,0 C181.9,150.8,183.4,152.3,183.4,154.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M190.2,135.1c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3l0,0 C188.7,131.8,190.2,133.2,190.2,135.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M205,47.5c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0 C203.5,44.1,205,45.6,205,47.5C205,47.4,205,47.4,205,47.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M217.4,40.3c0,1.8-1.4,3.3-3.3,3.4c-1.8,0-3.3-1.4-3.4-3.3s1.4-3.3,3.3-3.4c0,0,0,0,0,0 C215.9,37,217.4,38.5,217.4,40.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik7);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_7.1b0d265810b7a89ea7ea545604fc81d9.svg";
export { ForwardRef as ReactComponent };